import React from 'react';
import './Field.module.css';
import { Field } from 'formik';
import styles from './TextAreaCustom.module.css';
import {login} from "../../services/AuthService";

const TextAreaCustom = ({ label, type, name, placeholder, id = name, onChange = null }) => {
    return (
        <div className={styles.container}>
            <label htmlFor={id}>{label}</label>
            <Field
                as="textarea"
                type={type}
                id={id}
                name={name}
                placeholder={placeholder}
                className={styles.champ}
                // onChange={onChange ?? ((e) => console.log(e))}
            />
        </div>
    );
};

export default TextAreaCustom;
